import getSelectedText from 'browser-selected-text';
import PopupTypes from '../../../components/PopupTypes';
import { ChatActions } from '../../../components/ChatActions';

export const STREAM_CLICK_POPUP_OPEN = 'STREAM_CLICK_POPUP_OPEN';
export const CLICKED_OUTSIDE_POPUP = 'CLICKED_OUTSIDE_POPUP';
export const USER_CLICK_POPUP_OPEN = 'USER_CLICK_POPUP_OPEN';
export const POPUP_RESIZE_PROBABLY_HAPPENED = 'POPUP_RESIZE_PROBABLY_HAPPENED';
export const CHAT_MESSAGE_CONTEXT_MENU = 'CHAT_MESSAGE_CONTEXT_MENU';
export const GAME_FILTER_CONTEXT_MENU = 'GAME_FILTER_CONTEXT_MENU';
export const ROOM_CONTEXT_MENU = 'ROOM_CONTEXT_MENU';
export const POPUP_CLOSE = 'POPUP_CLOSE';
export const REPORT_PLAYER_POPUP_OPEN = 'REPORT_PLAYER_POPUP_OPEN';

export const USER_SEARCH_HEADER_BAR_OPEN = 'USER_SEARCH_HEADER_BAR_OPEN';
export const USER_SEARCH_HEADER_BAR_CLOSE = 'USER_SEARCH_HEADER_BAR_CLOSE';

export const reportPlayer = (player, contextData) => {
	ChatActions.reportToMods('Reporting ' + player.username, null, contextData);
	return {
		type: REPORT_PLAYER_POPUP_OPEN
	};
};

export const toggleUserSearchHeaderBar = () => (dispatch, getState) => {
	const { userSearchHeaderBarOpen } = getState().popups;
	if(userSearchHeaderBarOpen) {
		dispatch(closeUserSearchHeaderBar());
	}
	else {
		dispatch(openUserSearchHeaderBar());
	}
};

export const openUserSearchHeaderBar = () => {
	return {
		type: USER_SEARCH_HEADER_BAR_OPEN
	};
};
export const closeUserSearchHeaderBar = () => {
	return {
		type: USER_SEARCH_HEADER_BAR_CLOSE
	};
};

export const streamLinkClick = (stream, coordinates) => {
	return {
		type: STREAM_CLICK_POPUP_OPEN,
		payload: {
			stream,
			coordinates
		}
	};
};

export const closePopup = () => {
	return {
		type: POPUP_CLOSE
	};
};

export const clickedOutsidePopup = closePopup;

export const gameFilterContextMenu = (preferredGameFilter, coordinates, event) => {
	if(event) {
		event.preventDefault();
	}
	return {
		type: GAME_FILTER_CONTEXT_MENU,
		payload: {
			preferredGameFilter,
			coordinates,
			event
		}
	};
};

export const chatMessageContextMenu = (chatMessage, coordinates, event) => {
	if(event) {
		if(getSelectedText()) {
			return closePopup();
		}
		event.preventDefault();
	}
	return {
		type: CHAT_MESSAGE_CONTEXT_MENU,
		payload: {
			chatMessage,
			user: chatMessage.player,
			coordinates,
		}
	};
};

// The room menu for a room in the Rooms list. menu: { index, total, onMove(toIndex), onOpenRoom(room) }
// from the list it was opened in; without index there is no Move row.
export const roomContextMenu = (chatRoom, coordinates, menu = {}, event = null) => {
	if(event) {
		event.preventDefault();
	}
	return {
		type: ROOM_CONTEXT_MENU,
		payload: {
			chatRoom,
			coordinates,
			menu,
		}
	};
};

export const popupResizeProbablyHappened = () => {
	return {
		type: POPUP_RESIZE_PROBABLY_HAPPENED
	};
};

export const userProfileOpen = (user, coordinates, contextData) => {
	return userClickPopupOpen(user, PopupTypes.PROFILE_CARD, coordinates, contextData);
};

export const userClickPopupOpen = (user, popupType, coordinates, contextData) => {
	return {
		type: USER_CLICK_POPUP_OPEN,
		payload: {
			user,
			popupType,
			coordinates,
			contextData
		}
	};
};

